import { DeveloperSingleCardTemplate } from "../../../../../templates";
import { EditForm } from "../../../../shared";
import { useEdit } from "./useEdit";

export const Edit = (): JSX.Element => {
  const {
    pageTitle,
    dataIsLoading,
    userDetails,
    userUuid,
    roles,
    rolesInfo,
    userSettingsRoute,
    backButtonText,
    handleBackClick,
  } = useEdit();

  return (
    <div>
      {!dataIsLoading && (
        <DeveloperSingleCardTemplate
          activeElement="Settings"
          pageTitle={pageTitle}
          handleBackClick={handleBackClick}
          backButtonText={backButtonText}
        >
          {userDetails && (
            <EditForm
              userUuid={userUuid}
              defaultRoleValue={userDetails.role}
              defaultActiveValue={userDetails.active}
              firstName={userDetails.user.firstName}
              lastName={userDetails.user.lastName}
              email={userDetails.user.email}
              roles={roles}
              rolesInfo={rolesInfo}
              rowVersion={userDetails.rowVersion}
              userSettingsRoute={userSettingsRoute}
            />
          )}
        </DeveloperSingleCardTemplate>
      )}
    </div>
  );
};
